import { createSlice } from '@reduxjs/toolkit'

export const accountLiveDataSourcesSlice = createSlice({
  name: 'liveDataSources',
  initialState: [],
  reducers: {
    addLiveData(state, action) {
      state.push(action.payload)
    }
  },
})

export const { actions, reducer } = accountLiveDataSourcesSlice
export default reducer
